export default __webpack_public_path__ + "static/media/ali-profile.b737569d.png";